import { render, staticRenderFns } from "./AgentDigitalLeadOrders.vue?vue&type=template&id=40c788da&"
import script from "./AgentDigitalLeadOrders.vue?vue&type=script&lang=js&"
export * from "./AgentDigitalLeadOrders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports